import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { GenericService } from 'src/app/generic.service';
import { ScreenSize } from 'src/app/models';

@Component({
  selector: 'app-previous-year-dialog',
  templateUrl: './previous-year-dialog.component.html',
  styles: [
  ]
})
export class PreviousYearDialogComponent implements OnInit {
  previousYears: any;
  yearFileId: number;
  clientId: number;
  size: ScreenSize;

  constructor(
    public dialogRef: MatDialogRef<PreviousYearDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private router: Router, private service: GenericService) {
    this.previousYears = data.previousYears;
    this.clientId = data.clientId;
    this.size = service.size;
  }

  ngOnInit(): void {

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  createYearFile(year: number): void {
    const clientid = this.clientId;
    this.service.postDataByModel('InvoiceYear/CreateInvoiceYearByYearId', { Year: year, ClientId: clientid, IsAddedByTros: false }).then(response => {
      if (response.success) {
        this.yearFileId = response.dto;
        this.service.success('Case File has been created Successfully');
        this.dialogRef.close();
        this.service.setParams('yearfileid', response.dto);
        this.router.navigate(['/year']);
      } else {
        this.service.error(response.error);
      }
    });
  }

}
